export var generateExternalStyle = function generateExternalStyle() {
  return {
    showReturnButton: true
  };
};